// DeviceFilterModal.js
import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';

const DeviceFilterModal = ({ open, onClose, onApplyFilters }) => {
    const [filters, setFilters] = useState({
        agencyId: '',
        location: '',
        status: '',
        bin: '',
        block: '',
        domain: '',
        siteNumber: '',
        deviceBank: '',
        deviceGroup: '',
        machineType: '',
        capacity: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: value,
        }));
    };

    const handleApplyFilters = () => {
        onApplyFilters(filters); // Pass the filters back to the parent component
        onClose(); // Close the modal
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>Filter Devices</DialogTitle>
            <DialogContent>
                <div className="grid grid-cols-2 gap-4">
                    <TextField
                        label="Agency ID"
                        name="agencyId"
                        value={filters.agencyId}
                        onChange={handleInputChange}
                        fullWidth
                    />
                    <TextField
                        label="Location"
                        name="location"
                        value={filters.location}
                        onChange={handleInputChange}
                        fullWidth
                    />
                    <TextField
                        label="Status"
                        name="status"
                        value={filters.status}
                        onChange={handleInputChange}
                        fullWidth
                    />
                    <TextField
                        label="Bin"
                        name="bin"
                        value={filters.bin}
                        onChange={handleInputChange}
                        fullWidth
                    />
                    <TextField
                        label="Block"
                        name="block"
                        value={filters.block}
                        onChange={handleInputChange}
                        fullWidth
                    />
                    <TextField
                        label="Domain"
                        name="domain"
                        value={filters.domain}
                        onChange={handleInputChange}
                        fullWidth
                    />
                    <TextField
                        label="Site Number"
                        name="siteNumber"
                        value={filters.siteNumber}
                        onChange={handleInputChange}
                        fullWidth
                    />
                    <TextField
                        label="Device Bank"
                        name="deviceBank"
                        value={filters.deviceBank}
                        onChange={handleInputChange}
                        fullWidth
                    />
                    <TextField
                        label="Device Group"
                        name="deviceGroup"
                        value={filters.deviceGroup}
                        onChange={handleInputChange}
                        fullWidth
                    />
                    <TextField
                        label="Machine Type"
                        name="machineType"
                        value={filters.machineType}
                        onChange={handleInputChange}
                        fullWidth
                    />
                    <TextField
                        label="Capacity"
                        name="capacity"
                        value={filters.capacity}
                        onChange={handleInputChange}
                        fullWidth
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">
                    Cancel
                </Button>
                <Button onClick={handleApplyFilters} variant="contained" color="primary">
                    Apply Filters
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeviceFilterModal;
